/**
 * The weight of a closed parcel the PS130 never weighed, typed by hand.
 *
 * Without a weight BRT cannot be asked for a label, and a broken scale must
 * not stop a shipment: the gesture writes who typed it (the server asks for
 * the identity confirmation). The comma is the Italian decimal mark, so «7,5»
 * is read as 7.5; anything that is not a number is not sent.
 */

import { useState } from 'react';

export interface PropsPesoAMano {
  readonly ordine: string;
  readonly progressivo: number;
  readonly barcode: string;
  readonly inCorso: boolean;
  readonly fai: (percorso: string, corpo?: unknown) => () => void;
}

function chili(testo: string): number | null {
  const n = Number(testo.trim().replace(',', '.'));
  return testo.trim() === '' || !Number.isFinite(n) || n <= 0 ? null : n;
}

export function PesoAMano({ ordine, progressivo, barcode, inCorso, fai }: PropsPesoAMano) {
  const [testo, setTesto] = useState('');
  const pesoKg = chili(testo);

  return (
    <form
      className="mods"
      style={{ marginTop: 8 }}
      onSubmit={(e) => {
        e.preventDefault();
        if (pesoKg !== null) fai(`/fine-linea/${ordine}/colli/${progressivo}/peso`, { pesoKg })();
      }}
    >
      <label className="campo" style={{ margin: 0 }}>
        <span className="campo__k">Peso a mano · {barcode} · kg</span>
        <input inputMode="decimal" value={testo} onChange={(e) => setTesto(e.target.value)} />
      </label>
      <button type="submit" className="btn" disabled={inCorso || pesoKg === null}>
        Salva peso
      </button>
    </form>
  );
}
